import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import AdvanceSearchBallot from '../../pages/ballots/advance-ballot-search';
import AdvanceSearchWorkitem from '../../pages/WorkItems/advance-workitem-search';

type Option = {
    text: string;
    value: string;
    key: string;
  };
interface Props {
    onAdvanceSearchSubmit: (formData: any, type: string) => {},
    toggleAdvanceSearchVisibility?: () => void,
    committeeData: any,
    ballotDesignationData: any,
    wiListData: any,
    witnListData: any,
    standardListData: any,
    setAdvBallotSearchFormData: any,
    setAdvWorkitemSearchFormData: any,
    ballotAdvanceSearchFormData: any,
    wiAdvanceSearchFormData: any,
    popoverRef: any,
    ballotGlobalSearchTextRef: any;
    ballotStatusOption: Option[];
    wiStatusOption: Option[];
    onGlobalSearchSubmit: (option: string, text: string) => void;
    currentSearchOption?: string;
}
const AdvanceSearchPopOver: React.FC<Props> = (props) => {    
    const [showAdvanceSearchBallots, setShowAdvanceSearchBallots] = useState<boolean>(true);

    return (
      <div ref={props.popoverRef} className="advanced-search">
        {showAdvanceSearchBallots && props.currentSearchOption == "ballot" && <AdvanceSearchBallot ballotStatusOption={props.ballotStatusOption} onGlobalSearchSubmit={props.onGlobalSearchSubmit} {...props} />}

        {showAdvanceSearchBallots && props.currentSearchOption == "workitem" && <AdvanceSearchWorkitem ballotStatusOption={props.ballotStatusOption} wiStatusOption={props.wiStatusOption} onGlobalSearchSubmit={props.onGlobalSearchSubmit} {...props} />}
      </div>
    );
};

export default AdvanceSearchPopOver;
